import { createApiCall } from 'lib/base';

interface CreateAccountPasswordBody {
  password: string;
}

const CREATE_ACCOUNT_PASSWORD = 'CREATE_ACCOUNT_PASSWORD';

export const createAccountPasswordApi = createApiCall<
  CreateAccountPasswordBody
>(CREATE_ACCOUNT_PASSWORD, body => ({
  endpoint: `api/admin/account/create-password`,
  method: 'POST',
  body: JSON.stringify(body),
  // the page shows its own message (e.g. password too weak)
  skipDefaultErrorMessage: true,
}));

export default createAccountPasswordApi;
